import React, { useState } from 'react';
import styles from '../styles/LoginPage.module.scss';
import { login } from '../api/authApi';
import {useNavigate} from 'react-router-dom';
import {toast} from "react-toastify";

export default function LoginPage() {
    const navigate = useNavigate();
    const [loginValue, setLoginValue] = useState('');
    const [password, setPassword] = useState('');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await login({ login: loginValue, password });
            localStorage.setItem('adminAccessToken', response.data.accessToken);
            localStorage.setItem('adminRefreshToken', response.data.refreshToken);
            navigate("/admin")
        } catch (error) {
            const errorMessage =
                'Ошибка авторизации: ' + (error.response?.data?.message || "");
            toast.error(errorMessage);
        }finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={styles.wrapper}>
            <form className={styles.form} onSubmit={handleSubmit}>
                <h1 className={styles.title}>АДМИН-ПАНЕЛЬ</h1>
                <input
                    className={styles.input}
                    type="text"
                    placeholder="Логин"
                    value={loginValue}
                    onChange={(e) => setLoginValue(e.target.value)}
                />
                <input
                    className={styles.input}
                    type="password"
                    placeholder="Пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button className={styles.button} type="submit" disabled={isSubmitting}>{isSubmitting ? "Вход..." : "Войти"}</button>
            </form>
        </div>
    );
}
